import React from 'react';

import { Card, CardText, Row, Col, Button } from 'reactstrap';

const ReadAboutAndVideos = () => (
  <Row className="py-3">
    <Col xs="12" md="6">
      <Card block className="border-0 px-2 px-xl-4">
        <a
          className="btn btn-outline-secondary btn-lg py-sm-3"
          href="/about"
        >
          <span className="d-flex flex-row justify-content-center align-items-center">
            About Joe
          </span>
        </a>
      </Card>
    </Col>
    <Col xs="12" md="6">
      <Card block className="border-0 px-2 px-xl-4">
        <a
          className="btn btn-outline-secondary btn-lg py-sm-3"
          href="/videos"
        >
          <span className="d-flex flex-row justify-content-center align-items-center">
            Browse Videos
          </span>
        </a>
      </Card>
    </Col>
  </Row>
);

export default ReadAboutAndVideos;



// WEBPACK FOOTER //
// ./src/HomeReadAboutAndVideos.js